import React from 'react'

export default function Loader() {
  return (
    <div className='loader-section'>
    <div className="loader">
        <img src={require('../../assets/images/logo-0.png')} alt="" />
      <span></span>
    </div>
  </div>
  )
}
